import React from 'react';
import styles from '../../styles/cr.module.scss';
import { DateService } from '../../services/DateService';

export interface ICrLastEditProps {
    author: string;
    editDate: Date;
    lead?: string;
    additionalItemsString?: string;
}

export const CrLastEdit = ({ author, editDate, lead, additionalItemsString }: ICrLastEditProps): React.ReactElement =>
    <div style={{ paddingTop: '5px' }} className={styles.fontColorNeutralTertiary}>
        {author && editDate &&
            <span style={{ fontSize: '15px', fontStyle: 'italic' }}>Lead: {lead}, Last edited by: {author} at {DateService.dateToUkTime(editDate)} on {DateService.dateToUkDate(editDate)}{additionalItemsString && additionalItemsString} </span>
        }
    </div>;
